<app-header></app-header>
<div class="wrapper">
  <div class="section_wrapper" style="margin-top: 80px;padding-bottom: 0px;">
    <div class="sign_in_box" *ngIf="hideFields">
      <h6 class="font_40_a32">
        EMAIL
      </h6>
      <mat-error *ngIf="errorEmail" class="emailError">
        Please enter your registered email
      </mat-error>
      <p class="font_20_a32_700">
      </p>
      <form class="example-form input" [formGroup]="Emailform" (ngSubmit)=validateEmail()>
        <div class="form">
          <div class="w-100">
            <mat-form-field class="example-full-width">
              <mat-label>Enter your registered email</mat-label>
              <input matInput type="text" placeholder="" name="Email" formControlName="email">
            </mat-form-field>
            <mat-error
              *ngIf="(Emailform.get('email').hasError('required') || Emailform.get('email').hasError('pattern') )&& isSubmitted">
              Please
              enter a
              valid email address
            </mat-error>
          </div>
        </div>
        <div class="login">
          <button class="login_btn green_btn" *ngIf="!isLoader">CONTINUE
            <img src="../../../assets/icons/arrow_white.svg" alt="">
          </button>
          <app-loader *ngIf="isLoader"></app-loader>
        </div>

      </form>
    </div>
    <div class="display_email" *ngIf="!hideFields">
      <p class="font_20_a32_700">An email to reset password has been sent to {{emailAddress}}</p>
    </div>
  </div>
</div>
<app-footer></app-footer>